"use client";

import type { EventPayload, FormVariant } from "@homeinstead/analytics";
import type { ButtonVariantProps } from "@homeinstead/ui/components/Button";

import { track } from "@homeinstead/analytics";
import { scrollToTop } from "@homeinstead/shared";
import { Button } from "@homeinstead/ui/components/Button";
import { useEffect, useState } from "react";
import { trackLegacyLeadFormStep } from "./track-legacy-lead-form-step";

type TrackingEvent = {
  eventName: string;
  eventPayloadGenerator: () => EventPayload;
};

/**
 * Payload for the unified "Lead Form Step" event dual-fired alongside the
 * legacy `tracked_click` event during the 2-month transition period.
 */
type LeadFormStepPayload = {
  stepName: string;
  userSelection?: Record<string, string | string[]>;
  formVariant: FormVariant;
  pageZone?: string;
};

const ContinueButton = ({
  isEnabled,
  nextStep,
  trackingEvent,
  variant = "primary",
  leadFormStep,
}: {
  nextStep: () => void;
  isEnabled: boolean;
  trackingEvent: TrackingEvent;
  variant?: ButtonVariantProps["variant"];
  /**
   * When provided, fires the unified "Lead Form Step" Segment event immediately
   * after the legacy `tracked_click` event (dual-fire transition strategy).
   */
  leadFormStep?: LeadFormStepPayload;
}) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // TODO stop suppressing this warning (don't replicate this!)
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsClient(true);
  }, []);

  const handleNextStep = () => {
    if (!isClient) {
      console.warn("Calling handleNextStep on the server");
      return;
    }

    track(trackingEvent.eventName, trackingEvent.eventPayloadGenerator());

    if (leadFormStep) {
      trackLegacyLeadFormStep({
        formVariant: leadFormStep.formVariant,
        pageZone: leadFormStep.pageZone,
        stepName: leadFormStep.stepName,
        userSelection: leadFormStep.userSelection,
      });
    }

    // Scroll to the top of the page on each new step
    scrollToTop();

    nextStep();
  };

  return (
    <Button
      className="mt-4 h-12 w-full rounded-full"
      disabled={!isEnabled}
      onClick={handleNextStep}
      type="button"
      variant={variant}
    >
      Continue
    </Button>
  );
};

export default ContinueButton;
